module.exports = {"id":"201363","name":"Ryder Matos","rating":"73","photo":"./data/images/photos/0/201363.png","club":{"name":"Hellas Vérone","logo":"./data/images/clubs/HellasVerone.png"},"positions":["ATT","BU","AD","AG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RyderMatos0.json
// module id = 3766
// module chunks = 0